import axios from "axios";
import { Eye } from "phosphor-react";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";

import PhoneInput from "react-phone-input-2";
import { useHistory, useParams } from "react-router-dom";
import { handleInputs } from "../../utils/HandleInputs";
import { showToast } from "../../utils/ToastHelper";
import { BASE_URL } from "../Const/Url";
import Loader from "../CustomCommons/Loader";
import RequiredLabel from "../CustomCommons/RequiredLabel";
import * as path from "../Routes/RoutePaths";
import division from "../../assets/json/bd_divisions.json";
import { logout_func2 } from "../Const/logoutCommon";

const EditCustomer = () => {
  const [divisionOption, setDivisionOption] = useState(division);
  const [districtOption, setDistrictOption] = useState([]);
  const [cityOption, setCityOption] = useState([]);
  const [divisionData, setDivisionData] = useState();
  const [districtData, setDistrictData] = useState({});
  const [cityData, setCityData] = useState({});
  const history = useHistory();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [singleCustomer, setSingleCustomer] = useState({});
  const [cCode, setCCode] = useState("880");
  const [status, setStatus] = useState(false);
  const [fileName, setFileName] = useState("");
  const [URL, setURL] = useState("");
  const [Categoryswitch, setCategoryswitch] = useState(true);
  const [userAllData, SetuserAllData] = useState({
    name: "",
    customer_email: "",
    customer_mobile: "",
    customer_address: "",
    total_purchase: "",
    to_address2: "",
    to_zip_code: "",
    to_city: "",
    to_country: "Bangladesh",
    to_district: "",
    to_division: "",
  });
  const toggleSwitch = () => {
    setCategoryswitch((current) => !current);
  };
  const fileHandle = (e) => {
    // setProfileImage(e.target.files[0]);
    setFileName(e.target.files[0].name);
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    setURL(reader.result);
    reader.onload = () => {
      if (reader.readyState === 2) {
        setURL(reader.result);
      }
    };
  };
  const removeImg = () => {
    setStatus(!status);
  };
  // console.log(userAllData,'--------------user all data-----------')

  const getSingleUser = () => {
    const url = `${BASE_URL}api/v1/inventory/inventory/customer/${id}/`;
    axios
      .get(url)
      .then((res) => {
        if (res.data.status) {
          setSingleCustomer(res.data.data);
          console.log(res.data.data, "--------------customer------------");
          //   setProfileImage(res.data.data.image)
          setStatus(res.data.data?.status);
          SetuserAllData({
            name: res.data.data.name,
            customer_email: res.data.data.email,
            customer_mobile: res.data.data.mobile.replace("+880", ""),
            total_purchase: res.data.data.total_purchase,
            customer_address: res.data.data.to_address,
            to_address2: res.data.data.to_address2,
            to_zip_code: res.data.data.to_zip_code,
            to_city: res.data.data.to_city,
            to_country: res.data.data.to_country === 'null' ? "Bangladesh" : res.data.data.to_country,
            to_district: res.data.data.to_district,
            to_division: res.data.data.to_division,
          });
          setCategoryswitch(res.data.data.status);
          setDivisionData(res.data.data?.redex_division_details);
          setDistrictData(res.data.data?.redex_district_details);
          setCityData(res.data.data?.redex_area_details);
          // setIsLoading(false);
        }
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        console.log(errorMsg);
      });
  };
  const getDivission = () => {
    const url = `${BASE_URL}/api/v1/utility/admin/redex-address/${divisionData?.id}`
    axios
      .get(url)
      .then((res) => {
        const district = res.data.data.districts
        setDistrictOption(district)
        setIsLoading(false);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        setIsLoading(false)
        if (
          message === "Invalid token." ||
          JSON.parse(err.request.response).code === 401
        ) {
          logout_func2(0, history);
        }
      });
  };

  useEffect(()=>{
    getDivission()
  },[divisionData])

  useEffect(()=>{
    const areaData = districtOption?.filter(data => data?.id == districtData?.id)
    setCityOption(areaData[0]?.areas)
  },[districtData ,districtOption])
  // hlw----------------------------
  const updateCustomer = () => {
    const url = `${BASE_URL}api/v1/inventory/inventory/customer/${id}/`;
    const phone = `${cCode}${userAllData["customer_mobile"]}`;
    const data = new FormData();
    data.append("name", userAllData["name"]);
    data.append("email", userAllData["customer_email"]);
    data.append("mobile", `+${cCode}${userAllData["customer_mobile"]}`);
    data.append("to_address", userAllData["customer_address"]);
    data.append("to_address2", userAllData.to_address2);
    data.append("to_zip_code", userAllData.to_zip_code);
    
    data.append("to_country", userAllData.to_country ? userAllData.to_country :'Bangladesh');
    data.append("to_district", userAllData.to_district);
    data.append("redex_district", districtData?.id);
    data.append("to_division", userAllData.to_division);
    data.append("redex_division", divisionData?.id);
    data.append("to_city", userAllData.to_city);
    data.append("redex_area", cityData?.id);
    // to_address2: "",
    // to_zip_code: "",
    // to_city: "",
    // to_country: "",
    // to_district: "",
    // to_division: "",
    axios
      .patch(url, data)
      .then((res) => {
        if (res.data.status) {
          // clearData();
          showToast("success", "Customer Updated.");
          history.push(path.customer_list);
          // history.push(path.user_list);
        }
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        console.log(errorMsg);
        for (let key in errorMsg) {
          showToast("error", `${key} : ${errorMsg[key][0]}`);
        }
        showToast("error", message);
      });
  };
  useEffect(() => {
    getSingleUser();
  }, []);

  console.log(cityOption,'cc')

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div
      className="side_components_container"
      style={{ background: "#FAFAFA", minHeight: "100vh" }}
    >
      <div className="bg-white ">
        <div
          className="d-flex align-items-center"
          style={{ padding: "20px 35px ", border: "0.5px solid #E0E0E0" }}
        >
          {/* <PlusCircle size={30} /> */}
          <h3 style={{ fontSize: "23px", marginTop: "6px" }}>Edit Customer</h3>
        </div>

        <div
          style={{
            paddingTop: "20px",
            padding: "20px 35px ",
            borderBottom: " 0.5px solid #E0E0E0",
            borderRight: " 0.5px solid #E0E0E0",
            borderLeft: "0.5px solid #E0E0E0",
          }}
        >
          <div className="row">
            <div className="col-12 col-md-6">
              {/* <RequiredLabel text=" Name" /> */}
              <p>Name</p>
              <InputGroup className="mb-3">
                <Form.Control
                  name="name"
                  value={userAllData["name"]}
                  onChange={(e) => handleInputs(e, SetuserAllData)}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>
            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="" /> */}
              <p>Email</p>
              <InputGroup className="mb-3">
                <Form.Control
                  name="customer_email"
                  value={userAllData["customer_email"]}
                  onChange={(e) => handleInputs(e, SetuserAllData)}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="" /> */}
              <p>Phone Number</p>

              <div className="d-flex phoneContainer ">
                <PhoneInput
                  inputClass="phoneinput"
                  enableSearch={true}
                  onChange={(e) => console.log(setCCode(e))}
                  country={"bd"}
                />
                <div className="w-100">
                  <Form.Control
                    name="customer_mobile"
                    value={userAllData["customer_mobile"]}
                    // onChange={(e) => handleInputs(e, SetuserAllData)}
                    aria-label="Input number"
                    placeholder="Input number"
                    aria-describedby="basic-addon1"
                    style={{ backgroundColor: "#FAFAFA" }}
                    className=" disabled"
                    // className="phone_insert_input disabled"
                  />
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="" /> */}
              <p>Address 1</p>
              <InputGroup className="mb-3">
                <Form.Control
                  name="customer_address"
                  value={userAllData["customer_address"]}
                  onChange={(e) => handleInputs(e, SetuserAllData)}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>
            <div className="col-12 col-md-6">
              <p>To Address 2</p>

              <InputGroup className="mb-3 ">
                <Form.Control
                  aria-label="Username"
                  name="to_address2"
                  value={userAllData["to_address2"]}
                  onChange={(e) => handleInputs(e, SetuserAllData)}
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>
            {/* zip */}
            <div className="col-12 col-md-6">
              <p>To Zipcode</p>

              <InputGroup className="mb-3 ">
                <Form.Control
                  aria-label="Username"
                  name="to_zip_code"
                  value={userAllData["to_zip_code"]}
                  onChange={(e) => handleInputs(e, SetuserAllData)}
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>
            {/* divi */}
            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="To Division" /> */}
              <p>To Division</p>

              <div className="mb-3" style={{ backgroundColor: "#FAFAFA" }}>
                <Form.Select
                  size="lg"
                  placeholder="---Select---"
                  onChange={(e) => {
                    setDivisionData({
                      id: Number(e.target.value),
                      name: e.target.options[e.target.selectedIndex].text,
                    });
                  }}
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                  value={divisionData?.id}
                >
                  <option value=" ">....</option>
                  {divisionOption?.map((data) => (
                    <option key={data.id} value={data.id}>
                      {data?.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div>
            {/* dist */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="To District" />

              <div className="mb-3" style={{ backgroundColor: "#FAFAFA" }}>
                <Form.Select
                  size="lg"
                  placeholder="---Select---"
                  onChange={(e) => {
                    setDistrictData({
                      id: e.target.value,
                      name: e.target.options[e.target.selectedIndex].text,
                    });
                  }}
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                  value={districtData?.id}
                >
                  <option value=" ">....</option>
                  {districtOption?.map((data) => (
                    <option key={data.id} value={data.id}>
                      {data?.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div>

            {/* city */}
            <div className="col-12 col-md-6">
              <p>To City</p>

              <div className="mb-3" style={{ backgroundColor: "#FAFAFA" }}>
                <Form.Select
                  size="lg"
                  placeholder="---Select---"
                  onChange={(e) => {
                    setCityData({
                      id: e.target.value,
                      name: e.target.options[e.target.selectedIndex].text,
                    });
                  }}
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                  value={cityData?.id}
                >
                  <option value=" ">....</option>
                  {cityOption?.map((data) => (
                    <option key={data.id} value={data.id}>
                      {data?.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div>

            {/* country */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="To Country" />

              <InputGroup className="mb-3 ">
                <Form.Control
                  aria-label="Username"
                  name="to_country"
                  disabled
                  value={userAllData["to_country"]}
                  onChange={(e) => handleInputs(e, SetuserAllData)}
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              {/* <RequiredLabel text="" /> */}
              <p>Total Purchesed</p>
              <InputGroup className="mb-3 disabled">
                <Form.Control
                  name="total_purchase"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{ backgroundColor: "#FAFAFA" }}
                  disabled
                  value={`${userAllData["total_purchase"]} (not editable)`}
                  onChange={(e) => handleInputs(e, SetuserAllData)}
                />
              </InputGroup>
            </div>

            {/* --------------- */}
            <div className="row d-flex justify-content-between ">
              <div className="col-12 col-lg-5 d-none">
                <h5 style={{ marginTop: "30px" }}>Profile image</h5>
                <p style={{ color: "#8E8E93" }}>
                  ( Select your file & uploded )
                </p>
                <div
                  className="w-100 browse-main d-flex align-items-center"
                  style={{
                    height: "55px",
                    border: "1px solid #E0E0E0",
                    borderRadius: "7px",
                  }}
                >
                  {fileName === "" ? (
                    <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                      No File Choosen
                    </p>
                  ) : (
                    <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                      {" "}
                      {fileName}
                    </p>
                  )}

                  <div className="file-up">
                    <input type="file" onChange={(e) => fileHandle(e)} />
                    <p>Browse</p>
                  </div>
                </div>
                {URL && (
                  <div className="my-2">
                    <img height={90} width={90} src={URL} alt="" /> <br />
                    <button
                      onClick={removeImg}
                      className="remove-btn btn btn-small mt-1  rounded"
                      style={{ border: "1px solid gray !important" }}
                    >
                      Remove
                    </button>
                  </div>
                )}
              </div>

              {/* ----------status--------- */}
              <div className="col-12 col-lg-5 d-none">
                <h5 style={{ marginTop: "30px" }}>Status</h5>
                <p style={{ color: "#8E8E93" }}>
                  ( If the Category Option is available )
                </p>
                <div className="row mr-4">
                  <div
                    className=" d-flex justify-content-between col-12 py-3"
                    style={{
                      backgroundColor: "#F2F2F7",
                      borderRadius: "8px",
                    }}
                  >
                    <div className="d-flex w-100">
                      <div
                        className="d-flex py-1 justify-content-center align-items-center"
                        style={{
                          backgroundColor: "#212121",
                          width: "32px",
                          height: "32",
                          borderRadius: "3px",
                        }}
                      >
                        <Eye size={20} color={"white"} />{" "}
                      </div>
                      <span className="mx-3">
                        {Categoryswitch ? "ON" : "OFF"}
                      </span>
                    </div>

                    <div class="form-check form-switch ">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                        width={40}
                        height={40}
                        name="category_active"
                        checked={Categoryswitch}
                        onClick={toggleSwitch}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-2 mt-md-4" style={{ marginLeft: "-10px" }}>
                <button
                  className="save-btn me-2 mt-2"
                  style={{ background: "#000", color: "white" }}
                  onClick={updateCustomer}
                >
                  Save
                </button>
                <button
                  onClick={() => history.push(path.customer_list)}
                  className="save-btn mt-2"
                >
                  Cancel
                </button>
              </div>
            </div>
            {/* --------------- */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCustomer;
